import { render, staticRenderFns } from "./SetLeadsAsCompleted.vue?vue&type=template&id=528a9070&"
import script from "./SetLeadsAsCompleted.vue?vue&type=script&lang=js&"
export * from "./SetLeadsAsCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports